import { Cloud } from '@cast/shared-types';
import { PermissionsCenterFeature } from '@cast/types-permissions-center';

import { isFeatureRequiredBySelection } from './_utils';
import { SUPPORTED_CLOUD_PROVIDERS } from './constants';
import type { AllFeatureTypes, SupportedCloudProvider } from './types';

export const getTotalPermissionsCount = ({
  features,
  selectedFeatures,
}: {
  features: PermissionsCenterFeature[];
  selectedFeatures: AllFeatureTypes[];
}): number => {
  return features.reduce((total, feature) => {
    if (
      isFeatureRequiredBySelection({
        feature,
        selectedFeatureTypes: selectedFeatures,
      })
    ) {
      total += feature.basePermissionCount;
    }

    feature.subFeatures.forEach((subFeature) => {
      if (selectedFeatures.includes(subFeature.type)) {
        total += subFeature.maxPermissionCount;
      }
    });

    return total;
  }, 0);
};

/**
 * Accepts both `Cloud` enum values and raw strings so it works for
 * URL-parsed values (string) and API responses (Cloud).
 */
export const isSupportedCloudProvider = (
  value: Cloud | string
): value is SupportedCloudProvider =>
  !!value &&
  SUPPORTED_CLOUD_PROVIDERS.some((cloudProvider) => cloudProvider === value);
